import React from 'react'
import GAOrganizationDetailsContainer from '../../modules/GAOrganizations/containers/GAOrganizationDetailsContainer/GAOrganizationDetailsContainer'

const GAOrganizationDetails = () => {
  return (
    <GAOrganizationDetailsContainer />
  )
}

export default GAOrganizationDetails